// extracted by mini-css-extract-plugin
module.exports = {"passage":"Passage_passage__3gEVx","verseNumber":"Passage_verseNumber__2D1-Z"};